var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-view"},[_c('the-header',{attrs:{"isHone":true}}),_c('div',{staticClass:"bigBox",attrs:{"id":"home-view"}},[_vm._v(" HOME ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }